import { render } from "./SimpleForm.vue?vue&type=template&id=685725cb"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"
script.render = render

export default script